var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLogin || _vm.isRegister
      ? _c("div", { staticClass: "zhezhao" })
      : _vm._e(),
    _vm._v(" "),
    _vm.isLogin || _vm.isRegister
      ? _c(
          "div",
          { staticClass: "box", staticStyle: { background: "#eeeeee" } },
          [
            _c("div", [
              _c("img", {
                staticClass: "tc-on shut",
                attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
                on: { click: _vm.closeModal }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "box-title",
                staticStyle: { background: "#3a3959" }
              },
              [
                _c("p", { staticStyle: { position: "relative" } }, [
                  _c("img", {
                    staticStyle: { width: "150px" },
                    attrs: { src: "/static/img/header-logo.png", alt: "" }
                  }),
                  _vm.version
                    ? _c("span", [_vm._v(_vm._s(_vm.version))])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isLogin
              ? _c("div", { staticClass: "login-mess" }, [
                  _c("ul", { staticClass: "login-nav" }, [
                    _c(
                      "li",
                      {
                        class: _vm.active == "pass" ? "active" : "",
                        on: {
                          click: function($event) {
                            _vm.changeState("pass")
                          }
                        }
                      },
                      [_c("span", [_vm._v("密码登录")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: _vm.active == "mess" ? "active" : "",
                        on: {
                          click: function($event) {
                            _vm.changeState("mess")
                          }
                        }
                      },
                      [_c("span", [_vm._v("短信登录")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: _vm.active == "qrcode" ? "active" : "",
                        on: {
                          click: function($event) {
                            _vm.changeState("qrcode")
                          }
                        }
                      },
                      [_c("span", [_vm._v("扫码登录")])]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } })
                  ]),
                  _vm._v(" "),
                  _vm.active == "pass"
                    ? _c("div", { staticClass: "log-by-pass" }, [
                        _c("p", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.signin.username,
                                expression: "signin.username"
                              }
                            ],
                            key: "pass-phone",
                            attrs: {
                              type: "text",
                              id: "phone",
                              placeholder: "手机号/邮箱"
                            },
                            domProps: { value: _vm.signin.username },
                            on: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.onSignin()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.signin,
                                  "username",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.signin.password,
                                expression: "signin.password"
                              }
                            ],
                            key: "pass-pass",
                            attrs: {
                              type: "password",
                              id: "password",
                              placeholder: "密码"
                            },
                            domProps: { value: _vm.signin.password },
                            on: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.onSignin()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.signin,
                                  "password",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "button",
                            {
                              staticClass: "login-btn",
                              on: {
                                click: function($event) {
                                  _vm.onSignin()
                                }
                              }
                            },
                            [_vm._v("登 录")]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active == "mess"
                    ? _c("div", { staticClass: "log-by-mess" }, [
                        _c(
                          "p",
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.signin.mobile,
                                  expression: "signin.mobile"
                                }
                              ],
                              key: "mess-phone",
                              staticClass: "vcode",
                              attrs: {
                                type: "text",
                                placeholder: "请输入手机号"
                              },
                              domProps: { value: _vm.signin.mobile },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  _vm.onSignin()
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.signin,
                                    "mobile",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "31%",
                                  height: "35px",
                                  "text-align": "left"
                                },
                                model: {
                                  value: _vm.signin.countryCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.signin, "countryCode", $$v)
                                  },
                                  expression: "signin.countryCode"
                                }
                              },
                              _vm._l(_vm.areaCode, function(item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.text,
                                    attrs: {
                                      label: item.value,
                                      value: item.value
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.text))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px"
                                        }
                                      },
                                      [_vm._v(_vm._s(item.value))]
                                    )
                                  ]
                                )
                              })
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.signin.validCode,
                                expression: "signin.validCode"
                              }
                            ],
                            key: "mess-code",
                            staticClass: "vcode",
                            attrs: { type: "text", placeholder: "验证码" },
                            domProps: { value: _vm.signin.validCode },
                            on: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.onSignin()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.signin,
                                  "validCode",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              ref: "signinVcodeBtn",
                              staticClass: "vcode-btn",
                              on: {
                                click: function($event) {
                                  _vm.getSiginValidCode()
                                }
                              }
                            },
                            [_vm._v("获取验证码")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "button",
                            {
                              staticClass: "login-btn",
                              on: {
                                click: function($event) {
                                  _vm.onSignin()
                                }
                              }
                            },
                            [_vm._v("登 录")]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active == "qrcode"
                    ? _c(
                        "div",
                        { staticClass: "log-by-qywx" },
                        [
                          _c("qrcode-login", { on: { login: _vm.redirectApp } })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active == "qywx"
                    ? _c(
                        "div",
                        { staticClass: "log-by-qywx" },
                        [
                          _c("qywx-login", {
                            on: {
                              login: _vm.redirectApp,
                              register: _vm.checkRegister
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-bottom" }, [
                    _vm.active == "qrcode"
                      ? _c("div", { staticStyle: { flex: "1" } }, [
                          _vm._v("打开"),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://saas-help.usoftchina.com/doc/app/download",
                                target: "_blank"
                              }
                            },
                            [_vm._v("华商云服APP")]
                          ),
                          _vm._v("扫一扫")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.active == "qywx"
                      ? _c("div", { staticStyle: { flex: "1" } }, [
                          _vm._v("打开企业微信扫一扫")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.active == "pass"
                      ? _c(
                          "a",
                          {
                            staticClass: "clickbtn",
                            attrs: {
                              href: _vm.$url.accountCenter + "/resetPassword",
                              target: "_blank"
                            }
                          },
                          [_vm._v("忘记密码? ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.active == "pass" ? _c("span", [_vm._v("|")]) : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "clickbtn",
                        on: { click: _vm.checkRegister }
                      },
                      [_vm._v(" 免费注册")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isRegister
              ? _c("div", { staticClass: "reg-mess" }, [
                  _c("p", { staticClass: "area" }, [
                    _c(
                      "label",
                      { staticClass: "field-label", attrs: { for: "area" } },
                      [_vm._v("地  区")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "area-box", attrs: { id: "area" } },
                      [
                        _c(
                          "el-radio",
                          {
                            staticClass: "area-item",
                            attrs: { label: "10", border: "", size: "medium" },
                            model: {
                              value: _vm.area,
                              callback: function($$v) {
                                _vm.area = $$v
                              },
                              expression: "area"
                            }
                          },
                          [_vm._v("中国大陆")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            staticClass: "area-item",
                            attrs: { label: "20", border: "", size: "medium" },
                            model: {
                              value: _vm.area,
                              callback: function($$v) {
                                _vm.area = $$v
                              },
                              expression: "area"
                            }
                          },
                          [_vm._v("其他地区")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loginStatus
                    ? _c(
                        "p",
                        [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "phone" }
                            },
                            [_vm._v("手  机")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.signup.mobile,
                                expression: "signup.mobile"
                              }
                            ],
                            staticClass: "vcode",
                            attrs: {
                              type: "text",
                              id: "phone",
                              placeholder: "请输入您的手机号码"
                            },
                            domProps: { value: _vm.signup.mobile },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.signup,
                                  "mobile",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "area-select",
                              attrs: { disabled: _vm.area == 10 },
                              model: {
                                value: _vm.signin.countryCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.signin, "countryCode", $$v)
                                },
                                expression: "signin.countryCode"
                              }
                            },
                            _vm._l(_vm.areaCode, function(item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.text,
                                  attrs: {
                                    label: item.value,
                                    value: item.value
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.text))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492a6",
                                        "font-size": "13px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.value))]
                                  )
                                ]
                              )
                            })
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginStatus
                    ? _c(
                        "p",
                        [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "phone" }
                            },
                            [_vm._v("手  机")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.signup.mobile,
                                expression: "signup.mobile"
                              }
                            ],
                            ref: "phone",
                            staticClass: "vcode",
                            attrs: {
                              type: "text",
                              id: "phone",
                              placeholder: "请输入您的手机号码"
                            },
                            domProps: { value: _vm.signup.mobile },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.signup,
                                  "mobile",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "area-select",
                              attrs: { disabled: _vm.area == 10 },
                              model: {
                                value: _vm.signin.countryCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.signin, "countryCode", $$v)
                                },
                                expression: "signin.countryCode"
                              }
                            },
                            _vm._l(_vm.areaCode, function(item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.text,
                                  attrs: {
                                    label: item.value,
                                    value: item.value
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.text))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492a6",
                                        "font-size": "13px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.value))]
                                  )
                                ]
                              )
                            })
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "label",
                      { staticClass: "field-label", attrs: { for: "vcode" } },
                      [_vm._v("验 证 码")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.signup.validCode,
                          expression: "signup.validCode"
                        }
                      ],
                      staticClass: "vcode",
                      attrs: {
                        type: "text",
                        id: "vcode",
                        placeholder: "请输入获得的验证码"
                      },
                      domProps: { value: _vm.signup.validCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.signup, "validCode", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "signupVcodeBtn",
                        staticClass: "vcode-btn",
                        on: {
                          click: function($event) {
                            _vm.getSigupValidCode()
                          }
                        }
                      },
                      [_vm._v("获取验证码")]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loginStatus
                    ? _c("p", [
                        _c(
                          "label",
                          {
                            staticClass: "field-label",
                            attrs: { for: "name" }
                          },
                          [_vm._v("姓  名")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.signup.userName,
                              expression: "signup.userName"
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "name",
                            placeholder: "请输入您的真实姓名"
                          },
                          domProps: { value: _vm.signup.userName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.signup,
                                "userName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginStatus
                    ? _c("p", [
                        _c(
                          "label",
                          {
                            staticClass: "field-label",
                            attrs: { for: "name" }
                          },
                          [_vm._v("姓  名")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.signup.userName,
                              expression: "signup.userName"
                            }
                          ],
                          ref: "name",
                          attrs: {
                            type: "text",
                            id: "name",
                            placeholder: "请输入您的真实姓名"
                          },
                          domProps: { value: _vm.signup.userName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.signup,
                                "userName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.area == 10
                    ? _c(
                        "p",
                        [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "company" }
                            },
                            [_vm._v("企业名称")]
                          ),
                          _vm._v(" "),
                          _c("search-box", {
                            staticStyle: { width: "75%" },
                            attrs: {
                              id: "company",
                              readonly: !_vm.allowEditCompanyName
                            },
                            on: {
                              select: function($event) {
                                _vm.onCompanySelect($event)
                              }
                            },
                            model: {
                              value: _vm.signup.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.signup, "companyName", $$v)
                              },
                              expression: "signup.companyName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.area == 10
                    ? _c("p", [
                        _c("label", { staticClass: "field-label" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.signup.businessCode,
                              expression: "signup.businessCode"
                            }
                          ],
                          attrs: {
                            type: "text",
                            readonly: "",
                            placeholder: "统一社会信用代码"
                          },
                          domProps: { value: _vm.signup.businessCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.signup,
                                "businessCode",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.area == 20
                    ? _c("p", [
                        _c("label", { staticClass: "field-label" }, [
                          _vm._v("企业名称")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.signup.companyName,
                              expression: "signup.companyName"
                            }
                          ],
                          attrs: { type: "text", placeholder: "企业名称" },
                          domProps: { value: _vm.signup.companyName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.signup,
                                "companyName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.area == 20
                    ? _c("p", [
                        _c("label", { staticClass: "field-label" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.signup.businessCode,
                              expression: "signup.businessCode"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "统一社会信用代码"
                          },
                          domProps: { value: _vm.signup.businessCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.signup,
                                "businessCode",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.signup.inviteCode
                    ? _c("p", [
                        _c(
                          "label",
                          {
                            staticClass: "field-label",
                            attrs: { for: "company" }
                          },
                          [_vm._v("专属顾问")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partner.name,
                              expression: "partner.name"
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "inviteCode",
                            readonly: "readonly"
                          },
                          domProps: { value: _vm.partner.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.partner, "name", $event.target.value)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "area" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "field-label",
                          attrs: { for: "businessType" }
                        },
                        [_vm._v("业务类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox-group",
                        {
                          on: {
                            change: function($event) {
                              _vm.selectServe()
                            }
                          },
                          model: {
                            value: _vm.versionList,
                            callback: function($$v) {
                              _vm.versionList = $$v
                            },
                            expression: "versionList"
                          }
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "1" } }, [
                            _vm._v("贸易")
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "2" } }, [
                            _vm._v("制造")
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "3" } }, [
                            _vm._v("研发")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "juzhong" }, [
                    _c(
                      "button",
                      {
                        staticClass: "confirm",
                        on: {
                          click: function($event) {
                            _vm.onSignup()
                          }
                        }
                      },
                      [_vm._v("注 册")]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loginStatus
                    ? _c("p", { staticClass: "checklogin juzhong" }, [
                        _vm._v("\n        已有账号?\n        "),
                        _c("span", { on: { click: _vm.checkLogin } }, [
                          _vm._v("立即登录")
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isWxRegister
      ? _c("div", { staticClass: "box", staticStyle: { background: "#fff" } }, [
          _c("div", { staticStyle: { position: "relative" } }, [
            _c("span", {
              staticClass: "saas sa-chahao",
              on: { click: _vm.closeWxWin }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wx-mess" }, [
            _c("p", { staticClass: "wx-text" }, [_vm._v("企业微信注册")]),
            _vm._v(" "),
            _c("div", { staticClass: "imgbox" }, [
              _c("div", { staticClass: "imgcontent" }, [
                _vm.kindActive === "make"
                  ? _c("img", {
                      attrs: { src: "/static/img/make-app.png", alt: "" }
                    })
                  : _vm.kindActive === "trade"
                  ? _c("img", {
                      attrs: { src: "/static/img/trade-app.png", alt: "" }
                    })
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v(
                "请使用企业微信扫描二维码注册" +
                  _vm._s(_vm.kindActive == "make" ? "制造云" : "贸易云")
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { display: "block", width: "100%", height: "100%" },
        attrs: { src: "/static/img/colordiv.png", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "notice" }, [
      _c("span", { staticStyle: { "margin-left": "23%", color: "red" } }, [
        _vm._v("*")
      ]),
      _vm._v("注册即是表示同意\n        "),
      _c(
        "a",
        {
          attrs: {
            href: "https://saas-help.usoftchina.com/doc/base/service_protocol",
            target: "_blank"
          }
        },
        [_vm._v("《华商云服平台服务条款》")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f728308a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f728308a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/loginbox.vue
// module id = null
// module chunks = 